import SlideOutButton from "../common/SlideOutButton";
import useDevLockStagedPurchaseOrder from "./useDevLockStagedPurchaseOrder";

interface LockStagedPurchaseOrderButtonProps {
  stagedPurchaseOrderId: string;
}

const LockStagedPurchaseOrderButton = ({ stagedPurchaseOrderId }: LockStagedPurchaseOrderButtonProps) => {
  const lockRequest = useDevLockStagedPurchaseOrder(stagedPurchaseOrderId);

  return <SlideOutButton text="Lock Staged Purchase Order" onClick={() => lockRequest.request()} />;
}

export default LockStagedPurchaseOrderButton;
